/* Pasek zakupu na telefonie.
   Pokazuje sie dopiero, gdy hero zjedzie z ekranu, i chowa sie przy stopce,
   zeby nie zaslanial ostatniej sekcji. Na desktopie w ogole nie startuje. */
(function () {
  function init() {
    var bar = document.querySelector('[data-vv-buybar]');
    if (!bar) return;
    if (!window.matchMedia || !window.matchMedia('(max-width: 749px)').matches) return;

    document.body.classList.add('vv-has-buybar');

    var anchor = document.querySelector('.vv-hero') || document.querySelector('#pakiety');
    var stop = document.querySelector('.vv-foot');
    var pastHero = false;
    var atEnd = false;

    function apply() {
      if (pastHero && !atEnd) { bar.classList.add('is-on'); }
      else { bar.classList.remove('is-on'); }
    }

    if ('IntersectionObserver' in window && anchor) {
      new IntersectionObserver(function (entries) {
        pastHero = !entries[0].isIntersecting;
        apply();
      }, { rootMargin: '-40px 0px 0px 0px' }).observe(anchor);

      if (stop) {
        new IntersectionObserver(function (entries) {
          atEnd = entries[0].isIntersecting;
          apply();
        }, { rootMargin: '0px 0px -20px 0px' }).observe(stop);
      }
    } else {
      pastHero = true;
      apply();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
